import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pageView } from "@/lib/analytics";

/**
 * Fires a GA4 `page_view` on every client-side route change.
 * Mount this component once inside <BrowserRouter>.
 */
export default function AnalyticsRouterHook() {
  const location = useLocation();
  useEffect(() => {
    pageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}
